export const OutboundIcon = () => (
	<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
		<rect width="40" height="40" rx="4" fill="#684103" />
		<path d="M8.0625 35.0944L26.927 16.23L28.0027 32.4024" stroke="white" strokeWidth="3" />
		<path d="M10.0972 25.9644L28.9617 7.09981L16.5539 6.02412" stroke="white" strokeWidth="3" />
	</svg>
);
